import { getApi } from "../../../../controller/api"
import { API_CODE } from "../../../../controller/constants"

export const restartService = async (cookies) => {
    return await getApi(cookies.lottmekong, API_CODE.RESTART_SERVICE)
}
